import React, { FC } from "react";
import { useSelector } from "react-redux";

import { Layer } from "../../Map/components/Layer";
import { getLayerTempFilterTool } from "../../../ducks/layerTempFilter/selectors";
import { useSharedLayers } from "../../../hooks/sharing/useSharedLayers";
import { useTempLayerConditions } from "../../../hooks/layer/useTempLayerConditions";
import { useTempFilter } from "../../../hooks/filter/useTempFilter";

export const SharedLayers: FC = () => {
  // TODO should be one composite layer but now spcore fail on fetch extent for composite layer
  const layers = useSharedLayers();
  const conditions = useTempLayerConditions(true, true);
  const layerFilterTool = useSelector(getLayerTempFilterTool);
  const [tempFilterId] = useTempFilter();

  return (
    <>
      {layers.map(({ name, opacity, isVisible }, index) => (
        <Layer
          key={name}
          name={name}
          zIndex={index + 1}
          isDisplayed={isVisible}
          opacity={opacity}
          condition={conditions[name]}
          dataFilterId={layerFilterTool.layerName === name ? tempFilterId : undefined}
        />
      ))}
    </>
  );
};
